(ns common.db.coeffects.sub
  "Forked from https://github.com/den1k/re-frame-utils/blob/master/src/vimsical/re_frame/cofx/inject.cljc"
  (:require [common.re-frame :as cr]
            [re-frame.core :as rf]
            [reagent.ratom]))

(defn- sub-cofx-handler
  "Inject the `:sub` cofx.
  If `query-vector-or-event->query-vector-fn` is a subscription vector, subscribe and
  dereference that subscription before assoc'ing its value in the coeffects map
  under the id of the subscription and disposing of it.
  If `query-vector-or-event->query-vector-fn` is a fn, it should take a single
  argument which is the event args vector for that handler (similar to the
  2-arity of `re-frame.core/reg-sub`). Its return value should be a query-vector
  or nil. From there on the behavior is similar to when passing a query-vector.
  NOTE that if there are no components subscribed to that subscription the cofx
  will dispose of it in order to prevent leaks. However, there is a performance
  penalty to doing this since we pay for a re-frame subscription cache miss
  every time we inject it. A rule of thumb for what to do here would be that
  if an injected sub is disposed of very often, we should either rework the subscription
  graph so that it ends up used by a component and thus cached, or we should extract the
  db lookup logic into a function that can be used to get the value straight from the db
  inside the handler. It seems safe to decide to ignore the warning when the
  disposal doesn't happen too often, and it is just more convenient to reuse the
  subscription's logic.

  Examples:

  (require '[vimsical.re-frame.cofx.inject :as inject])

  ;; Injecting a simple subscription:
  (re-frame/reg-sub ::simple ...)
  (re-frame/reg-event-fx ::simple-handler
   [(re-frame/inject-cofx :sub [::simple]]]
   (fn [{:as cofx {::keys [simple]} params]
     ...)

  ;; Injecting similar subscriptions and mapping them to different keys:
  (re-frame/reg-sub ::simple ...)
  (re-frame/reg-event-fx ::simple-handler
   [(re-frame/inject-cofx :sub {::a [::simple 1]
                                ::b [::simple 2]]
   (fn [{:as cofx {::keys [a b]} params]
     ...)

  ;; Injecting a dynamic subscription depending on the event parameters:
  (re-frame/reg-sub ::dynamic (fn [_ [_ arg1 arg2]] ...))
  (re-frame/reg-event-fx ::dynamic-handler
   [(re-frame/inject-cofx :sub
      (fn [[_ arg1 arg2]]
        ...
        [::dynamic arg1 arg2]))]
   (fn [{:as cofx {::keys [dynamic]} [_ arg1 arg-2]]
     ...)
  "
  [cofx param]
  (let [eval-subscription (fn [param]
                            (let [[id query-vector] (cond
                                                      (keyword? param) [param [param]]
                                                      (vector? param) [(first param) param]
                                                      (ifn? param) (let [query-vector (param (:event cofx))]
                                                                     [(first query-vector) query-vector]))
                                  val @(cr/uncached-subscribe query-vector)]
                              [id val]))]
    (if (map? param)
      (into cofx
            (map (fn [[id v]]
                   (let [[_id val] (eval-subscription v)]
                     [id val])))
            param)
      (conj cofx (eval-subscription param)))))

;;
;; * Entry point
;;

(rf/reg-cofx :sub sub-cofx-handler)
